var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import BillHeader from './components/BillHeader';
import LeftTree from './components/LeftTree';
import SupplierTable from './components/Table';
import SupplierService from '../../api/SupplierService';
import { UrlHelper } from '../../helper/UrlWrapper';
import { Loading } from 'element-ui';
import { mapGetters } from 'vuex';
import _ from 'lodash';
var List = (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.total = 0;
        _this.data = [];
        _this.selectRows = [];
        _this.treeData = [];
        _this.categoryData = [];
        return _this;
    }
    List.prototype.mounted = function () {
        this.service = SupplierService.getInstance();
        this.getTreeCategoryData();
        this.search();
    };
    List.prototype.nodeClick = function (node) {
        if (node && node.category_id) {
            this.categoryId = node.category_id;
            var pagination = this.$refs.pagination;
            pagination.clear();
            this.search(pagination.getPage());
        }
    };
    List.prototype.nodeCollapse = function () {
        this.categoryId = '';
        var pagination = this.$refs.pagination;
        pagination.clear();
        this.search(pagination.getPage());
    };
    List.prototype.getTreeCategoryData = function (data) {
        var _this = this;
        var CALL_BACK = function (arr) {
            _this.categoryData = arr;
            _this.treeData = [{
                    category_name: '全部类别',
                    category_id: '',
                    children: _.cloneDeep(arr)
                }];
        };
        if (data) {
            CALL_BACK(data);
            return;
        }
        this.service.getCategory({ page: 1, start: 0, limit: 100 }).then(function (res) {
            CALL_BACK(res.data.data || []);
        });
    };
    List.prototype.handleExport = function (keywords) {
        var selectRows = this.selectRows || [];
        var supplier_upper_id = selectRows.map(function (item) { return item.supplier_upper_id; });
        var params = {
            sort_field: this.order ? this.order[0] : undefined,
            sort_type: this.order ? this.order[1] : undefined,
            category_id: this.categoryId,
            keywords: keywords,
            supplier_upper_id: supplier_upper_id.join(',')
        };
        var url = "supplierclientapi/supplierupper/export";
        for (var key in params) {
            if (params[key]) {
                url = UrlHelper.addParam(url, key, params[key]);
            }
        }
        url = UrlHelper.addParam(url, 'token', this.user.token);
        console.log('------selectRows', url, this.selectRows, params);
        location.href = url;
    };
    List.prototype.pageChange = function () {
        this.search();
    };
    List.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            var sortfield = prop;
            if (sortfield === 'status_value') {
                sortfield = 'status';
            }
            else if (sortfield === 'supplier_upper_name') {
                sortfield = 'supplier_upper_pinyin';
            }
            this.order = [sortfield, order === 'ascending' ? 'asc' : 'desc'];
        }
        this.search();
    };
    List.prototype.keywordsChange = function (keywords) {
        this.keywords = keywords;
        var pagination = this.$refs.pagination;
        pagination.clear();
        this.search(pagination.getPage());
        this.search();
    };
    List.prototype.search = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            sort_field: this.order ? this.order[0] : undefined,
            sort_type: this.order ? this.order[1] : undefined,
            category_id: this.categoryId,
            keywords: this.keywords
        };
        this.service.getListUpper(Object.assign({}, pager, params)).then(function (res) {
            loadingInstance.close();
            _this.data = res.data.data;
            _this.total = res.data.total;
        }, function (err) {
            _this.$message.error(err.message || err.msg);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    List.prototype.setSelectRows = function (rows) {
        this.selectRows = rows;
    };
    List = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
            })),
            components: {
                'bill-header': BillHeader,
                'left-tree': LeftTree,
                'supplier-table': SupplierTable
            }
        })
    ], List);
    return List;
}(Vue));
export default List;
